<template>
  <div v-if="showOverlay" class="buybox__sticky--overlay" @click="toggleShowOptions(false)"></div>
  <div id="sticky-bar" class="buybox__sticky">
    <div class="buybox__sticky-wrapper">
      <div class="buybox__sticky-left">
        <div class="text-xl">{{ product.title}}</div>
        <div v-if="yotpoProductId" class="product__reviews">
          <div class="yotpo bottomLine" data-appkey="SmtoQBJliJwFrBjSYjmEtOz31o6nMoLZfgcp3J4j" :data-product-id="yotpoProductId"></div>
        </div>
      </div>
      <div v-if="selectedVariant" class="buybox__sticky-right">
        <div v-if="!showOptions" class="buybox__sticky-options">
          <div class="buybox__sticky-option">
            <template v-for="(option, index) in selectedVariant.options" :key="index">
              <span>{{  option }} </span>
              <span v-if="index != selectedVariant.options.length - 1" class="buybox__sticky-option-seperator"></span>
            </template>
          </div>
          <div  @click="toggleShowOptions(true)" class="buybox__sticky-option-change">Change</div>
        </div>
        <div :class="['buybox__sticky-inner', {'buybox__sticky--drpdwn': buyboxSubscription?.isFrequencyDrpdwnOpen}]" v-if="showOptions">
          <div class="buybox__sticky-close" aria-label="close" @click="toggleShowOptions(false)" tabindex="0">
            <svg class="buybox__sticky-close-icon">
              <use href="#exit"></use>
            </svg>
          </div>
          <BuyboxOptions
            :product="product"
            :selectedVariant="selectedVariant"
            @update-option="onUpdateOption"
          />
          <BuyboxSubscription 
            ref="buyboxSubscription"
            :product="product"
            :selectedVariant="selectedVariant"
            :isMultiPack="isMultiPack"
            :selectedSellingPlan="selectedSellingPlan"
            :isSubscriptionProp="isSubscription"
            @update-option="onUpdateOption"
            @update-selling-plan="onUpdateSellingPlan"
            @update-is-subscription="onUpdateIsSubscription"
          />
        </div>
        <BuyboxATC
          :isMultiPack="isMultiPack"
          :isSubscription="isSubscription"
          :selectedVariant="selectedVariant"
          :selectedSellingPlan="selectedSellingPlan"
          @track-event="trackEvent"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, toRefs, inject } from 'vue';
  import BuyboxATC from './buybox-atc.vue';
  import BuyboxOptions from './buybox-options.vue';
  import BuyboxSubscription from './buybox-subscription.vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    selectedVariant: {
      type: Object,
      default: () => ({})
    },

    isMultiPack: {
      type: Boolean,
      default: false
    },

    yotpoProductId: {
      type: String,
      default: ''
    },

    selectedSellingPlan: {
      type: Object,
      default: null,
    },

    isSubscription: {
      type: Boolean,
      default: false
    }
  })

  const { product, selectedVariant } = toRefs(props);
  const showOverlay = ref(false);
  const showOptions = ref(false);
  const buyboxSubscription = ref(null);
  const emit = defineEmits(['update-option','update-selling-plan','update-is-subscription','track-event']);

  const onUpdateOption = (key,value,index) => {
    let tempSelectedOption = product.value.options[index].selected;
    emit('update-option',key,value,index)

    setTimeout(() => {
      if(key.toLowerCase() === 'size' && value == '20' && tempSelectedOption != value && buyboxSubscription.value) {
        buyboxSubscription.value.onSubscriptionChange(true)
      }

      if(!selectedVariant.value.has_subscription_plan && buyboxSubscription.value) {
        buyboxSubscription.value.isSubscription = false;
      }
    },10)
  }

  const onUpdateSellingPlan = (option,isSubscription) => {
    emit('update-selling-plan',option, isSubscription)
  }

  const onUpdateIsSubscription = (value) => {
    if(buyboxSubscription.value) {
      buyboxSubscription.value.isSubscription = value;
      emit('update-is-subscription',value) 
    }
  }

  const toggleShowOptions = (value) => {
    showOptions.value = value;
    if(value){
      showOverlay.value = true;
      document.body.style.overflow = 'hidden'
    }else{
      showOverlay.value = false;
      document.body.style.overflow = 'auto'
    }
  }

  const trackEvent = (value) => {
    emit('track-event',value)
  }
</script>